class Resizer {
  /**
   * 이미지 파일 크기 조절
   * @param base64Image base64 인코딩된 이미지
   * @param maxSize 최대 파일 크기(bytes)
   * @param isTransparent 배경이 투명할지(원본이 투명하지 않으면 의미 없음)
   * @param backgroundColor 배경이 투명하지 않을때 색상
   */
  byRoughSize(
    base64Image: string,
    maxSize: number,
    isTransparent: boolean = true,
    backgroundColor: string = '#FFFFFF',
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const image = new Image();

      if (base64Image.length < maxSize) {
        image.onload = () => {
          const elem = document.createElement('canvas');
          elem.width = image.naturalWidth;
          elem.height = image.naturalHeight;
          const ctx = elem.getContext('2d');
          if (ctx) {
            if (!isTransparent) {
              ctx.fillStyle = backgroundColor;
              ctx.fillRect(0, 0, image.naturalWidth, image.naturalHeight);
            } else {
              ctx.clearRect(0, 0, image.naturalWidth, image.naturalHeight);
            }
            ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight);
            resolve(ctx.canvas.toDataURL('image/png', 100));
          } else {
            reject();
          }
        };
      } else {
        image.onload = () => {
          const elem = document.createElement('canvas');
          elem.width = Math.round(image.naturalWidth / 2.0);
          elem.height = Math.round(image.naturalHeight / 2.0);
          const ctx = elem.getContext('2d');
          if (ctx) {
            ctx.drawImage(image, 0, 0, elem.width, elem.height);
            resolve(
              this.byRoughSize(ctx.canvas.toDataURL('image/png', 100), maxSize),
            );
          } else {
            reject();
          }
        };
      }

      image.src = base64Image;
    });
  }

  async byRoughSizeToFile(
    base64Image: string,
    maxSize: number,
    isTransparent: boolean = true,
    backgroundColor: string = '#FFFFFF',
  ): Promise<Blob> {
    const dataURL = await this.byRoughSize(
      base64Image,
      maxSize,
      isTransparent,
      backgroundColor,
    );

    const blobBin = atob(dataURL.substr(dataURL.indexOf(',') + 1));
    const array = [];
    for (let i = 0; i < blobBin.length; i += 1) {
      array.push(blobBin.charCodeAt(i));
    }

    return new Blob([new Uint8Array(array)], { type: 'image/png' });
  }

  async rotateImageIfNeeded(file: File): Promise<File> {
    if (!file.type.startsWith('image/')) {
      return file; // 이미지 아니면 무시
    }

    const img = new Image();
    const objectURL = URL.createObjectURL(file);

    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = (e) => reject(e);
      img.src = objectURL;
    });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    URL.revokeObjectURL(objectURL); // 메모리 정리

    const rotatedBlob = await new Promise<Blob>((resolve) => canvas.toBlob((blob) => resolve(blob!), file.type));

    // 새 File 반환 (EXIF 정보 제거됨)
    return new File([rotatedBlob], file.name, { type: file.type });
  }
}

export default new Resizer();
